export default {"src":"/_next/static/media/banner_limited_use_template.3aa9bb16.svg","height":25,"width":258,"blurWidth":0,"blurHeight":0};